module.exports = __webpack_public_path__ + "static/media/use_cases_for_the_world_v3_660_376.f6f5d11e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/usecases/use_cases_for_the_world_v3_660_376.gif
// module id = 1268
// module chunks = 0